import { StyleSheet } from 'react-native'

import { fontFamily, fontFamilyBold } from '../design-system/theme/partners/tokens'

export const styles = StyleSheet.create({
  headerTitle: {
    fontFamily: fontFamily,
    fontSize: 16,
    fontWeight: '700',
    paddingHorizontal: 8,
    // This allows the screen's title to wrap to the next line if it's too long
    overflow: 'visible',
    textAlign: 'center',
    lineHeight: 24,
    color: '#165B60',
  },
  headerTitleBold: {
    fontFamily: fontFamilyBold,
    fontSize: 16,
    fontWeight: '700',
    // This allows the screen's title to wrap to the next line if it's too long
    overflow: 'visible',
    textAlign: 'center',
    lineHeight: 24,
    color: '#165B60',
  },
  headerTitleLeft: {
    fontFamily: fontFamilyBold,
    fontSize: 20,
  },
  headerTitleHidden: {
    display: 'none',
  },
  headerBackTitle: {
    fontSize: 14,
    fontFamily: fontFamily,
  },
})

export default styles
